/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { isSodimacStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef } from 'react';
import { track } from '../../external_dependencies/analytic/index';
import { InstallmentsStyles } from './InstallmentsWithoutInterest.style';
import UnifiedCMRInformation from './UnifiedCMRInformation';

const InstallmentsWithoutInterest = ({ product, userSegments, isUserLoggedIn, appCtx, regionCode }) => {
  const isTrackedRef = useRef(false);
  const { installmentsWithoutInterest = [] } = product;
  const segments = useMemo(() => userSegments, [userSegments]);
  const isLoggedIn = useMemo(() => isUserLoggedIn, [isUserLoggedIn]);
  const isInstallmentsEnabledForKiosk = appCtx?.siteConfig?.toggles.isInstallmentsEnabledForKiosk ?? false;

  useEffect(() => {
    if (isLoggedIn && window && window?.digitalData) {
      const userSegmentNames = segments?.map((segmentItem) => segmentItem?.name)?.join('|');
      window.digitalData.usersegment = userSegmentNames || null;
    }
  }, [segments, isLoggedIn]);

  const { store } = appCtx;
  const isSodimacSA = isSodimacStandalone(store);

  if ((!installmentsWithoutInterest.length && !isSodimacSA) || (appCtx?.isKiosk && !isInstallmentsEnabledForKiosk)) {
    return null;
  }
  if (!installmentsWithoutInterest.length && isSodimacSA) {
    return <UnifiedCMRInformation appCtx={appCtx} regionCode={regionCode} product={product} />;
  }

  let maxInstallments = 0;

  if (isUserLoggedIn) {
    const userSegmentNames = segments?.map((segmentItem) => segmentItem.name);
    let isMatch = false;
    const filteredInstallmentsWithoutInterest = installmentsWithoutInterest.filter((itemWithoutInterest) => {
      if (!itemWithoutInterest?.userSegment?.length) {
        return itemWithoutInterest;
      }
      const isInstallmentsWithoutInterestInUserSegment = itemWithoutInterest.userSegment.some((itemUserSegment) =>
        userSegmentNames.includes(itemUserSegment)
      );
      isMatch = isMatch || isInstallmentsWithoutInterestInUserSegment;
      return isInstallmentsWithoutInterestInUserSegment && itemWithoutInterest;
    });
    const uniqueInstallments = [
      ...new Set(filteredInstallmentsWithoutInterest.map((item) => Number(item.installments))),
    ];

    maxInstallments = uniqueInstallments.length > 0 ? Math.max(...uniqueInstallments) : 0;

    if (
      maxInstallments > 0 &&
      isMatch &&
      !isTrackedRef.current &&
      typeof window !== 'undefined' &&
      window &&
      window._satellite
    ) {
      track('segmentedcsi');
      isTrackedRef.current = true;
    }
  } else {
    const itemWithHighestinstallment = installmentsWithoutInterest?.reduce((max, current) =>
      current.installments > max.installments ? current : max
    );

    if (itemWithHighestinstallment && !itemWithHighestinstallment?.userSegment?.length) {
      maxInstallments = itemWithHighestinstallment.installments;
    } else {
      return null;
    }
  }

  const renderInstallments = () => {
    return maxInstallments > 0 ? (
      <>
        <div className="installments-text">
          <span className="cmr-icon" />
          <span>{maxInstallments} cuotas sin interés</span>
        </div>

        <style jsx>{InstallmentsStyles}</style>
      </>
    ) : null;
  };
  return isSodimacSA ? (
    <UnifiedCMRInformation
      maxInstallments={maxInstallments}
      appCtx={appCtx}
      regionCode={regionCode}
      product={product}
    />
  ) : (
    renderInstallments()
  );
};

InstallmentsWithoutInterest.propTypes = {
  product: PropTypes.object.isRequired,
  appCtx: PropTypes.object.isRequired,
  userSegments: PropTypes.array.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  regionCode: PropTypes.string.isRequired,
};

export default InstallmentsWithoutInterest;
